import { Clock, ShieldCheck, RefreshCw, TrendingUp } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "@/components/Reveal";
import { Sigil } from "@/components/Sigil";

const OATHS = [
  { k: "reply", i: Clock, t: "1–2 business days", d: "I get back to every customer within 1 to 2 business days." },
  { k: "pro", i: ShieldCheck, t: "Professional work", d: "Clean files, sharp detail and a finish you can put your name on." },
  { k: "redo", i: RefreshCw, t: "Free image redo", d: "Not satisfied with your image? I'll redo it for free." },
  { k: "level", i: TrendingUp, t: "Next-level brand", d: "Visuals that take your business and push it to the next level." },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="relative overflow-hidden py-28 sm:py-40 border-t border-[var(--line)]">
    <Sigil className="absolute -right-40 top-10 w-[700px] h-[700px] text-[var(--arcane)]/15 spin-slow pointer-events-none" />
    <div className="relative max-w-[1400px] mx-auto px-5 sm:px-10 grid lg:grid-cols-12 gap-14">
      <Reveal className="lg:col-span-6">
        <Eyebrow n="04">About</Eyebrow>
        <SectionTitle>A graphic designer who builds <span className="italic text-gilded">empires</span>.</SectionTitle>
        <div className="mt-8 space-y-5 text-[var(--ink-dim)] text-base sm:text-lg leading-relaxed max-w-xl">
          <p>
            I'm a graphic designer behind King App Graphics. I make graphic art, image-to-video art, videos,
            profile pictures, cover art, advertisements and websites.
          </p>
          <p>
            If you've got a business, a brand or a vision, I'm the one who can take it and lift it to the next level —
            with visuals that look expensive and feel like you.
          </p>
        </div>
      </Reveal>
      <div className="lg:col-span-6 grid sm:grid-cols-2 gap-4 content-start">
        {OATHS.map((o, idx) => {
          const I = o.i;
          return (
            <Reveal key={o.k} delay={idx * 0.08}>
              <div data-testid={`about-oath-${o.k}`} className="group h-full p-7 border border-[var(--line)] bg-[var(--crypt)]/80 backdrop-blur-sm hover:border-[var(--blood)] transition-colors duration-500">
                <I className="w-6 h-6 text-[var(--blood)] transition-transform duration-500 group-hover:scale-125" />
                <h3 className="font-display text-xl font-bold mt-6">{o.t}</h3>
                <p className="text-sm text-[var(--ink-dim)] mt-2 leading-relaxed">{o.d}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
